import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import beachImg from "../assets/images/beach.jpg";
import mountainImg from "../assets/images/mountains.jpg";
import cityImg from "../assets/images/city.jpg";
import PackagesSection from "../components/PackagesSection";

const slides = [
  {
    img: beachImg,
    title: "Discover Dreams Travel",
    subtitle: "Explore the beautiful beaches of Oman",
  },
  {
    img: mountainImg,
    title: "Adventure Awaits",
    subtitle: "Climb the majestic mountains",
  },
  {
    img: cityImg,
    title: "City Lights",
    subtitle: "Experience vibrant culture & tours",
  },
];

const Home: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <div style={{ maxWidth: "100vw", overflowX: "hidden" }}>
      {/* <Slider {...settings}>
        {slides.map((slide, idx) => (
          <div key={idx} style={{ position: "relative" }}>
            <img
              src={slide.img}
              alt={slide.title}
              style={{ width: "100vw", height: 300, objectFit: "cover" }}
            />
            <div
              style={{
                position: "absolute",
                top: "20%",
                left: "10%",
                maxWidth: "60%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                padding: "10px",
                borderRadius: "8px",
                color: "white",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                textShadow: "2px 2px 8px rgba(0,0,0,0.9)",
                zIndex: 10,
              }}
            >
              <h2
                style={{
                  fontSize: "2.5rem",
                  margin: 0,
                  fontWeight: "bold",
                  color: "#ffcc00",
                }}
              >
                {slide.title}
              </h2>
              <p
                style={{
                  fontSize: "1.2rem",
                  marginTop: "0.5rem",
                  fontStyle: "italic",
                }}
              >
                {slide.subtitle}
              </p>
            </div>
          </div>
        ))}
      </Slider> */}
      {/* New white tiles below slider */}
    {/* <section
      style={{
        backgroundColor: "#f0f0f0",
        padding: "2rem 1rem",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          maxWidth: 1000,
          width: "100%",
          display: "flex",
          gap: "1.5rem",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {slides.map((slide, idx) => (
          <div
            key={idx}
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              width: 280,
              padding: "1rem",
              textAlign: "center",
            }}
          >
            <img
              src={slide.img}
              alt={slide.title}
              style={{
                width: "100%",
                height: 160,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: "1rem",
              }}
            />
            <h3 style={{ margin: "0 0 0.5rem" }}>{slide.title}</h3>
            <p style={{ color: "#555", fontSize: "0.95rem" }}>{slide.subtitle}</p>
          </div>
        ))}
      </div>
    </section> */}
    <PackagesSection />
    </div>
  );
};

export default Home;
